import { useVIPEditGetVipsForEventByIdQuery } from '@graphql/generated';

export const useVIPList = (eventId: string) => {
  const { data, loading, refetch, error } = useVIPEditGetVipsForEventByIdQuery({
    variables: {
      id: eventId,
    },
    batchMode: 'fast',
  });

  return { data: data?.eventById?.vips || [], loading, refetch, error };
};
